export const ABS_SECTOR_GROUP_KEY = {
  ABS: 'ABS',
  CLO: 'CLO',
  CMBS: 'CMBS',
  RMBS: 'RMBS',
} as const;

export type AbsSectorGroupKey = typeof ABS_SECTOR_GROUP_KEY[keyof typeof ABS_SECTOR_GROUP_KEY];

export interface IAbsSectorGroup {
  key: AbsSectorGroupKey,
  label: string,
  sectorIds: string[],
}
